import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

import _ from "lodash";
import * as moment from "moment";

declare let $: any;

@Injectable({
  providedIn: "root",
})
export class TaskService {
  constructor(public http: HttpClient) {}

  list(inParams: any = {}): any {
    const params = {...inParams};

    if (params.$page) {
      params.$skip = (params.$page - 1) * (params.$limit);
    }
    delete params.$page;

    if (!params.status) {
      delete params.status;
    }

    if (params.routine === 'all') {
      delete params.routine;
    }

    if (params.assigner === 'all') {
      delete params.assigner;
    }

    if (params.$search) {
      params.title = {$like: `%${params.$search}%`};
      delete params.$search;
    }

    const query = $.param(params);
    const url = `${environment.taskSharingApiUrl}/tasks?${query}`;
    return this.http.get(url);
  }

  save(model): any {
    if (model.id) {
      const updateUrl = `${environment.taskSharingApiUrl}/tasks/${model.id}`;
      return this.http.patch(updateUrl, model);
    }

    delete model.id;
    const url = `${environment.taskSharingApiUrl}/tasks`;
    return this.http.post(url, model);
  }

  detail(id): any {
    const url = `${environment.taskSharingApiUrl}/tasks/${id}`;
    const params: any = {
      $populate: ["user", "author", "assigner"],
    };

    return this.http.get(url, { params });
  }

  delete(model): any {
    const url = `${environment.taskSharingApiUrl}/tasks/${model.id}`;
    return this.http.delete(url);
  }

  percentage(item) {
    if (!item) {
      return 0;
    }
    
    if (item.status === 'completed') {
      return 100;
    }

    const {goals} = item;

    if (goals && goals.length) {
      const completedGoals = _.filter(goals, (o: any) => o.status === 'completed');

      return (completedGoals.length / goals.length * 100).toFixed(0);
    }

    return 0;
  }

  countItems(items = [], status = 'completed') {

    if (status === 'overdue') {
      const $today = moment().startOf("day");

      let count = 0;
      for (let item of items) {
        const $startDate = moment(item.start_date).endOf("day");
        if ($startDate.isBefore($today) && item.status !== 'completed') {
          count ++;
        }
      }

    return count
    }

    return items.filter(o => o.status === status).length;
  }
}
